// extracted by mini-css-extract-plugin
export var carrierTab = "_3l-0";
export var carrierTabActive = "_3l-1 _3l-0";
export var carrierTabInactive = "_3l-2 _3l-0";
export var carrierTabLabel = "_3l-3";
export var carrierTabLabelActive = "_3l-4 _3l-3";
export var carrierTabLabelInactive = "_3l-5 _3l-3";
export var carrierTabPercentage = "_3l-6";
export var carrierTabPercentageActive = "_3l-7 _3l-6";
export var carrierTabPercentageInactive = "_3l-8 _3l-6";
export var carrierTabWinnable = "_3l-9";
export var carrierTabWinnableActive = "_3l-a _3l-9";
export var carrierTabWinnableInactive = "_3l-b _3l-9";
export var comparisonContainer = "_3l-d";
export var missingRateButton = "_3l-n";
export var missingRateButtonActive = "_3l-o _3l-n";
export var missingRateButtonInactive = "_3l-p _3l-n";
export var missingRateButtonLabel = "_3l-q";
export var missingRateButtonLabelActive = "_3l-r _3l-q";
export var missingRateButtonLabelInactive = "_3l-s _3l-q";
export var sidebar = "_3l-c";
export var strategyButton = "_3l-e";
export var strategyButtonActive = "_3l-f _3l-e";
export var strategyButtonDescription = "_3l-k";
export var strategyButtonDescriptionActive = "_3l-l _3l-k";
export var strategyButtonDescriptionInactive = "_3l-m _3l-k";
export var strategyButtonInactive = "_3l-g _3l-e";
export var strategyButtonLabel = "_3l-h";
export var strategyButtonLabelActive = "_3l-i _3l-h";
export var strategyButtonLabelInactive = "_3l-j _3l-h";
export var unitToggleButton = "_3l-t";
export var unitToggleButtonActive = "_3l-u _3l-t";
export var unitToggleButtonInactive = "_3l-v _3l-t";
export var unitToggleButtonLabel = "_3l-w";
export var unitToggleButtonLabelActive = "_3l-x _3l-w";
export var unitToggleButtonLabelInactive = "_3l-y _3l-w";